import React, { useMemo, useEffect, useState, useLayoutEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Beat } from "../../../../plugins/spinners.plugin";
import Button from "../../../../components/buttons/buttons";
import Table from "../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../components/skeleton/table";
import TableFilter from "../../../../components/tables/tableFilter";
import { Pagination } from "../../../../components/pagination/pagination";
import EmptyState from "../../../../assets/images/emptyState/food.svg";
import FilterFoodDropDown from "../../../../components/dropDown/filter/filterFood";
import { AllFiltersModal } from "../../../../components/modals/allFiltersModal";
import {
  filterRewardsAction,
  searchRewardsAction,
  getAllRewardsActionNoPagination,
} from "../../../../redux/reward/rewardActions";
import rewardType from "../../../../redux/reward/rewardTypes";
import { writeFileWithXLSX } from "../../../../components/exports/xlsx";

export default function Unapprove() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { page } = useParams();

  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
  });
  const [payLoad] = useState({
    management_approved: 0,
  });

  const { allRewards, downloading } = useSelector((state) => state.reward);
  const { filtering, searching } = useSelector((state) => state.reward);

  useEffect(() => {
    dispatch(filterRewardsAction(payLoad, page));
    // eslint-disable-next-line
  }, [page]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((reward, index) => {
        let show = {
          id: index + 1,
          reward_id: reward.id,
          title: reward?.title,
          points: reward?.points,
          count: reward?.configuration?.count,
          validity: reward?.configuration?.validity,
          rewardData: reward,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  function createTableDataDownload(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((reward, index) => {
        let show = {
          id: index + 1,
          reward_id: reward.id,
          title: reward?.title,
          points: reward?.points,
          count: reward?.configuration?.count,
          validity: reward?.configuration?.validity,
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  useLayoutEffect(() => {
    const dataSet = createTableData(allRewards?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRewards]);

  function goToSinglePage(params) {
    let id = params?.show?.rewardData?.id;
    navigate(`/admin/rewards/${id}`, {
      state: { reward: params?.show?.rewardData },
    });
  }

  function goToCreate() {
    navigate(`/admin/rewards/create`);
  }

  const handleDownload = async () => {
    const response = await dispatch(
      getAllRewardsActionNoPagination({
        management_approved: 1,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableDataDownload(response?.data);
      writeFileWithXLSX(newData, {
        filename: "Unapproved_Rewards.xlsx",
        download: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allRewards?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: rewardType["SEARCH_REWARDS"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchRewardsAction(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "show.id",
          },
          {
            Header: "Reward ID",
            accessor: "show.reward_id",
          },
          {
            Header: "Title",
            accessor: "show.title",
          },
          {
            Header: "Point",
            accessor: "show.points",
          },
          {
            Header: "Count",
            accessor: "show.count",
          },
          {
            Header: "Validity",
            accessor: "show.validity",
          },
        ],
      },
    ],
    []
  );
  return (
    <div>
      <TableFilter
        title={"Rewards"}
        results={allRewards?.to}
        totalResults={allRewards?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        searchPlaceholder={"Search reward"}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterFoodDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
      >
        <Button.Primary title={"+ Create Reward"} onClick={goToCreate} />
        <Button.Secondary
          title={downloading ? <Beat color={"#CE2600"} /> : "Download CSV"}
          type="button"
          disabled={!data}
          onClick={handleDownload}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4 px-3">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="py-36 text-center">
            <div className="flex justify-center">
              <img src={EmptyState} className="w-auto" alt="no data" />
            </div>
            <h3 className="mt-5 text-xl font-bold">Rewards</h3>
            <p className="mt-2 text-sm text-[#9CA3AF]">
              You do not have any rewards yet.
            </p>
          </div>
        )}

        {!isSearchOpen && (
          <Pagination data={allRewards} route={"admin/food/approved"} />
        )}
      </div>
    </div>
  );
}
